import * as React from 'react';
import { Typography } from 'omakase';

interface Props {
  text: React.ReactNode;
  mb?: number;
  className?: string;
}

const Subheader = ({ mb = 2, text, className }: Props) => {
  return (
    <div className={className}>
      <Typography component="h3" mb={mb} variant="heading04">
        {text}
      </Typography>
    </div>
  );
};

export default Subheader;
